import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    services: [] as string[],
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [isServicesExpanded, setIsServicesExpanded] = useState(false);

  const services = [
    { id: 'tarjetas', label: 'Tarjetas de presentación' },
    { id: 'volantes', label: 'Volantes' },
    { id: 'invitaciones', label: 'Invitaciones' },
    { id: 'logos', label: 'Diseño de logos' },
    { id: 'facturas', label: 'Facturas o talonarios' },
    { id: 'avisos', label: 'Avisos publicitarios' },
    { id: 'stickers', label: 'Stickers' },
    { id: 'estampados', label: 'Estampados' },
    { id: 'pendones', label: 'Pendones' },
    { id: 'camisetas', label: 'Camisetas personalizadas' },
    { id: 'buzos', label: 'Buzos personalizados' },
    { id: 'gorras', label: 'Gorras personalizadas' },
    { id: 'mugs', label: 'Mugs personalizados' },
    { id: 'retablos', label: 'Retablos (cuadros o fotos)' },
    { id: 'diseno-grafico', label: 'Diseño gráfico' },
    { id: 'material-pop', label: 'Material POP' },
    { id: 'carnet', label: 'Carnet o escarapela' },
    { id: 'carpetas', label: 'Carpetas' },
    { id: 'cajas', label: 'Cajas personalizadas' },
    { id: 'bolsas', label: 'Bolsas personalizadas' },
    { id: 'manillas', label: 'Manillas VIP' },
    { id: 'pines', label: 'Pines' },
    { id: 'sellos', label: 'Sellos' },
    { id: 'botones', label: 'Botones publicitarios' },
    { id: 'folletos', label: 'Folletos' },
    { id: 'abanicos', label: 'Abanicos publicitarios' }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceChange = (serviceId: string) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.includes(serviceId)
        ? prev.services.filter(id => id !== serviceId)
        : [...prev.services, serviceId]
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('company', formData.company);
      formDataToSend.append('services', formData.services.join(', '));
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d3m839hvbfpiajvfc6k0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('¡Mensaje enviado exitosamente! Te contactaremos pronto.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          services: [],
          message: ''
        });
      } else {
        setSubmitStatus('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      setSubmitStatus('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="py-20 relative"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20customer%20service%20team%20with%20caucasian%20white%20people%20working%20in%20modern%20bright%20office%2C%20friendly%20business%20professionals%20smiling%2C%20diverse%20team%20of%20light-skinned%20designers%20and%20communication%20specialists%2C%20clean%20contemporary%20workspace%20with%20computers%20and%20printing%20materials%2C%20collaborative%20work%20environment%2C%20professional%20corporate%20atmosphere%20with%20natural%20lighting&width=1920&height=600&seq=contact-hero-white-team&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Contáctanos
            </h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              En Lion Urban la convertimos en algo grande, real y con actitud. Tu proyecto, nuestra pasión.
            </p>
          </div>
        </section>

        {/* Contact Form & Info */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Form */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Solicita tu Cotización
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Nombre Completo *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="Tu nombre completo"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Correo Electrónico *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="tu@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Teléfono
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-sm"
                        placeholder="+1 (555) 123-4567"
                      />
                    </div>
                    <div>
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                        Empresa
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-sm"
                        placeholder="Nombre de tu empresa"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-4">
                      Servicios de Interés
                    </label>
                    
                    {/* Dropdown Toggle Button */}
                    <div className="mb-4">
                      <button
                        type="button"
                        onClick={() => setIsServicesExpanded(!isServicesExpanded)}
                        className="w-full flex items-center justify-between px-4 py-3 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus-border-transparent text-sm transition-colors duration-200 cursor-pointer"
                      >
                        <span className="text-gray-700">
                          {formData.services.length > 0 
                            ? `${formData.services.length} servicio${formData.services.length > 1 ? 's' : ''} seleccionado${formData.services.length > 1 ? 's' : ''}`
                            : 'Selecciona los servicios que te interesan'
                          }
                        </span>
                        <i className={`ri-arrow-down-s-line text-gray-500 transition-transform duration-200 ${isServicesExpanded ? 'rotate-180' : ''}`}></i>
                      </button>
                    </div>

                    {/* Services Grid - Expandable */}
                    {isServicesExpanded && (
                      <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 max-h-80 overflow-y-auto">
                        <div className="grid grid-cols-1 sm-grid-cols-2 gap-3">
                          {services.map((service) => (
                            <div
                              key={service.id}
                              className={`relative border-2 rounded-lg p-3 transition-all duration-200 hover:shadow-md cursor-pointer ${
                                formData.services.includes(service.id)
                                  ? 'border-blue-500 bg-blue-50'
                                  : 'border-gray-200 bg-white hover:border-gray-300'
                              }`}
                              onClick={() => handleServiceChange(service.id)}
                            >
                              <div className="flex items-center">
                                <label
                                  htmlFor={service.id}
                                  className="text-sm font-medium text-gray-700 cursor-pointer select-none"
                                >
                                  {service.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {/* Selected Services Summary */}
                        {formData.services.length > 0 && (
                          <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                            <p className="text-sm font-medium text-blue-800 mb-2">
                              Servicios seleccionados ({formData.services.length}):
                            </p>
                            <div className="flex flex-wrap gap-2">
                              {formData.services.map((serviceId) => {
                                const service = services.find(s => s.id === serviceId);
                                return service ? (
                                  <span
                                    key={serviceId}
                                    className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full"
                                  >
                                    {service.label}
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleServiceChange(serviceId);
                                      }}
                                      className="ml-1 text-blue-600 hover:text-blue-800 cursor-pointer"
                                    >
                                      <i className="ri-close-line text-xs"></i>
                                    </button>
                                  </span>
                                ) : null;
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Mensaje *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows={5}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-sm resize-vertical"
                      placeholder="Cuéntanos sobre tu proyecto..."
                    ></textarea>
                    <div className="text-right text-sm text-gray-500 mt-1">
                      {formData.message.length}/500 caracteres
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white py-3 px-6 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                  </button>

                  {submitStatus && (
                    <div className={`p-4 rounded-lg ${submitStatus.includes('exitosamente') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {submitStatus}
                    </div>
                  )}
                </form>
              </div>

              {/* Contact Info */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Información de Contacto
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-map-pin-fill text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">Dirección</h3>
                      <p className="text-gray-600">
                        Bogotá, Colombia
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-phone-fill text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">Teléfono</h3>
                      <div className="text-gray-600 flex flex-wrap items-center gap-2">
                        <a 
                          href="https://wa.me/573209769166?text=Hola, me interesa conocer más sobre sus servicios de publicidad e impresión"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-green-600 transition-colors duration-200 cursor-pointer"
                        >
                          320 976 9166
                        </a>
                        <span className="text-gray-400">|</span>
                        <a 
                          href="https://wa.me/message/GG6UNVA6HN5UG1"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-green-600 transition-colors duration-200 cursor-pointer"
                        >
                          321 618 8801
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-mail-fill text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">Email</h3>
                      <p className="text-gray-600">
                        lionurbandesignprint@gmail.com
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-time-fill text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">Horarios</h3>
                      <p className="text-gray-600">
                        Lunes a Viernes: 8:00 AM - 7:00 PM<br />
                        Sábados: 9:00 AM - 5:00 PM<br />
                        Domingos: Cerrado
                      </p>
                    </div>
                  </div>
                </div>

                {/* WhatsApp CTA */}
                <div className="mt-8 p-6 bg-green-50 rounded-xl border border-green-200">
                  <div className="flex items-center mb-4">
                    <i className="ri-whatsapp-fill text-2xl text-green-600 mr-3"></i>
                    <h3 className="text-lg font-semibold text-gray-900">
                      ¿Necesitas una respuesta rápida?
                    </h3>
                  </div>
                  <p className="text-gray-600 mb-4">
                    Chatea con nosotros por WhatsApp y obten una cotización inmediata
                  </p>
                  <a
                    href="https://wa.me/573209769166?text=Hola, me interesa conocer más sobre sus servicios de publicidad e impresión"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-fill mr-2"></i>
                    Chatear Ahora
                  </a>
                </div>

                {/* Social Media */}
                <div className="mt-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Síguenos</h3>
                  <div className="flex space-x-4">
                    <a href="https://www.facebook.com/share/19gJu4pUHt/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors duration-200 cursor-pointer">
                      <i className="ri-facebook-fill"></i>
                    </a>
                    <a href="https://www.instagram.com/lionurbandesignprint?igsh=MXJkYjFtZjRuM2FpdA==" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-pink-600 text-white rounded-lg flex items-center justify-center hover:bg-pink-700 transition-colors duration-200 cursor-pointer">
                      <i className="ri-instagram-fill"></i>
                    </a>
                    <a href="https://www.tiktok.com/@lionurbandesignprint?_t=ZS-90Y5jfkYM1E&_r=1" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-black text-white rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors duration-200 cursor-pointer">
                      <i className="ri-tiktok-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
